/**
 * 主操作界面
 * @author A_Sir 2017-11-27
 *
 */
import { Component,ViewChild } from '@angular/core';
import { LoginComponent } from "../mainpage/login/login.component"
import { Router} from "@angular/router";
import { Headers, ResponseOptions, Http} from "@angular/http";
import { Cookie} from "ng2-cookies/ng2-cookies";
import { CustomerComponent} from "../mainpage/customer/customer.component";
import { HttpAddress} from "../service/httpaddress";
import {isNullOrUndefined} from "util";
import { ElementRef } from '@angular/core';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  @ViewChild(LoginComponent) childLogin: LoginComponent;
  @ViewChild(CustomerComponent) childCus: CustomerComponent;
  title = '码上有源客户服务系统';
  user:string="客户";
  isLogin:string;
  is_user:boolean = false;//右上角用户显示，以及退出按钮
  is_login:boolean = false;//登录界面
  is_login_success:boolean = true;//登陆提示
  is_message:boolean = true;//用户操作主界面
  count:number;
  existflag:number = 1;
  is_count:boolean = false;
  private headers = new Headers({'Content-Type': 'application/json'});
  private options = new ResponseOptions({headers:this.headers});
  private httpget = new HttpAddress();
  constructor(private route:Router,
              private http:Http,
              private element: ElementRef
  ){
  }
  ngDoCheck(){
    // if(this.is_message === true){
    //     this.element.nativeElement.querySelector("#middlebox").style.height = (window.innerHeight-198)+'px';
    //     // this.element.nativeElement.querySelector("#loading").style.top = (window.innerHeight-200)+'px';
    // }else{
    //     this.element.nativeElement.querySelector("#middlebox").style.height = window.innerHeight+'px';
    // }
    if(isNullOrUndefined(Cookie.get("usertoken"))&&this.existflag==1){
      //没有
      this.existflag = 0;
      this.existSys();
    }
    //检测子组件的登陆状态
    if(this.childLogin.is_clogin==0){
      this.is_login_success=true;
    }else{
      this.is_login_success=false;
    }
    //获得消息数量
    this.count =parseInt(Cookie.get("userallsize"));
    if(Cookie.get("userallsize")==undefined){
      this.count= 0;
    }
  }
  ngOnInit(){
    //检测是否存在已经登陆

    var cookie = Cookie.get('usertoken');
    if(cookie!=undefined){//存在
      this.user = Cookie.get('username');
      this.is_login = true;
      this.is_message = false;
      this.is_user = true;
      this.count =parseInt(Cookie.get("userallsize"));
    }else{
      this.is_login = false;
      this.count = 0;
    }
  }
  ngAfterViewInit(){

  }
  //返回主页
  backhome(){
    Cookie.delete("index");
    Cookie.set("index","0");
    this.childCus.index=0;
    this.route.navigate(["servicepage"]);
  }
  //退出系统
  existSys(){
    //清除cookie
    Cookie.delete("usertoken");
    Cookie.delete("username");
    Cookie.delete("userallsize");
    Cookie.delete("infor");
    Cookie.delete("firminfor");
    Cookie.delete("invoiceinfor");
    Cookie.delete("addressinfor");
    Cookie.delete("index");
    //退出界面切换
    this.is_login = false;
    this.is_message = true;
    this.is_user = false;
    this.isLogin = '';
    this.route.navigate(['servicepage']);
    //
    // location.reload(true);
  }
  //进入消息中心
  enterMes(bool){
    if(bool==false){
      this.route.navigate(['servicepage/message']);
      this.count=0;
      Cookie.delete("userallsize");
      Cookie.set("userallsize",this.count.toString());
      this.is_count = false;
    }
  }
  //获得子组件登录
  getLogin(json){
    var $ = this;
    $.isLogin = "正在登录。。。";
    $.http.post($.httpget.login(),json,$.options).subscribe(function (res) {
      if(res.json().code==2001){
        var token;
        $.user = res.json().data.user.username;//用户名；
        token = res.json().data.user.token;
        Cookie.set('usertoken', token,1/12);//存取token；
        Cookie.set('username', $.user,1/12);//存取用户名；
        Cookie.set("index","0");
        $.checkmes(token,$.user);
        Cookie.delete("userallsize");
        Cookie.set("userallsize",res.json().data.allsize.toString());
        $.count=parseInt(Cookie.get("userallsize"));
        //进入到用户操作界面
        $.childLogin.is_clogin = 0;
        $.is_login = true;
        $.is_message = false;
        $.is_user = true;
        //子组件内容清空
        $.childLogin.username='';
        $.childLogin.userpass='';
        $.childLogin.pass='';
        $.childLogin.name='';

      }else if(res.json().code==2004){
        $.isLogin="用户名和密码不匹配！"
      }else{
        $.isLogin="登录失败，请重新登录！";
      }
    });
  }
  //检测信息是否填写完全
  checkmes(token,name){
    var $this = this;
    var infor =  Cookie.get("infor");
      $this.headers.delete("token");
      $this.headers.append("token",token);
      $this.options = new ResponseOptions({headers:$this.headers});
      var json = {"username":name};
      $this.http.post($this.httpget.checkinfor(),JSON.stringify(json),$this.options).subscribe(function (res) {
        if(res.json().code==2001){
          Cookie.set("infor","ok");
        }else{
          Cookie.set("infor","notok");
        }
      });
    }
    checktoken(){
      if(isNullOrUndefined(Cookie.get("usertoken"))&&this.existflag==1){
        //没有
        this.existflag = 0;
        this.existSys();
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts